import { render, staticRenderFns } from "./ownerCertification.vue?vue&type=template&id=1554e14f&scoped=true&"
import script from "./ownerCertification.vue?vue&type=script&lang=js&"
export * from "./ownerCertification.vue?vue&type=script&lang=js&"
import style0 from "./ownerCertification.vue?vue&type=style&index=0&id=1554e14f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1554e14f",
  null
  
)

export default component.exports